// Write your code here.
import './index.css'

const NavBar = props => {
  const {score, topScore, gamePlay} = props
  console.log(props)
  // const topScores = score > topScore ? score : topScore
  if (gamePlay === true) {
    return (
      <nav className="navbar">
        <div className="nav_1">
          <img
            alt="emoji logo"
            className="emojilogo"
            src="https://assets.ccbp.in/frontend/react-js/game-logo-img.png "
          />
          <h1>Emoji Game</h1>
        </div>
        <div className="scores">
          <p>Score: {score}</p>
          <p>Top Score: {topScore}</p>
        </div>
      </nav>
    )
  }
  return (
    <nav className="navbar">
      <div className="nav_1">
        <img
          alt="emoji logo"
          className="emojilogo"
          src="https://assets.ccbp.in/frontend/react-js/game-logo-img.png "
        />
        <h1>Emoji Game</h1>
      </div>
    </nav>
  )
}

export default NavBar
